<section class="main-section">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">Drivers</li>
        </ol>
    </nav>
    <div class="row align-items-center">
        <div id="errorMessage2" class="invalid-feedback d-block" [hidden]="!errorMessage">{{errorMessage}}</div>
        <div class="col-6">
            <ul class="list-inline tab-list deskContent">
                <li class="list-inline-item"><a (click)="populateTabData('all','ALL');  tabChange();" [ngClass]="{'active': tabClicked === 'all'}">All</a></li>

                <li class="list-inline-item"><a (click)="populateTabData('active','ACTIVE');  tabChange();" [ngClass]="{'active': tabClicked === 'active'}">Active</a></li>
                <li class="list-inline-item"><a (click)="populateTabData('in_active','IN_ACTIVE'); tabChange();" [ngClass]="{'active': tabClicked === 'in_active'}">Inactive</a></li>
            </ul>
          <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2" [ngModelOptions]="{standalone: true}" (change)="populate(userDrop2)" style="width: 140px;" data-value="All" required>
            <option  value="ALL">All</option>
            <option  value="ACTIVE">Active</option>
            <option  value="IN_ACTIVE">Inactive</option>
          </select>
        </div>
        <div class="col-6 mt-md-0 text-right float-right">
          <a placement="bottom" ngbTooltip="Create" class="ml-3">
            <svg xmlns="http://www.w3.org/2000/svg" routerLink="/admin/createDrive" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563Zm4.645,8.9a.388.388,0,0,1-.387.387H9.853v2.968a.388.388,0,0,1-.387.387H7.659a.388.388,0,0,1-.387-.387V9.853H4.3a.388.388,0,0,1-.387-.387V7.659A.388.388,0,0,1,4.3,7.272H7.272V4.3a.388.388,0,0,1,.387-.387H9.466a.388.388,0,0,1,.387.387V7.272h2.968a.388.388,0,0,1,.387.387Z" transform="translate(2.823 3.938)"/></g></svg>
          </a>
            <!--<a routerLink="/admin/createDrive" class="btn btn-outline-primary btn-sm"><svg class="bi bi-plus mr-2" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
           <path fill-rule="evenodd" d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"></path>
           <path fill-rule="evenodd" d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"></path>
         </svg>Create</a>-->
<!--
            <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
-->

            <!--<button [hidden]="tabClicked == 'all'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn btn-outline-primary ml-2 dropdown-toggle " [disabled]="(!checkedList?.length)">Actions</button>
      <div class="dropdown-menu dropdown-menu2  dropdown-menu-right">
        <a *ngIf="tabClicked === 'active' || tabClicked === 'inactive' || tabClicked === 'all'" (click)="editDriver(driversList)" class="dropdown-item file btn shift-import">Edit</a>
      </div>-->
        </div>
    </div>


    <div class="row">
        <div class="col">
            <div class="inner-box d-none d-sm-block" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}" style="min-height:580px!important;">
                <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                    <thead>
                        <tr>
                            <th [hidden]="tabClicked == 'all'">
                                <div class="form-checkbox">
                                    <input type="checkbox" id="all_items" [(ngModel)]="masterSelected" name="list_name" value="m1" (change)="checkUncheckAll()" />
                                    <label for="all_items"></label>
                                </div>
                            </th>
                            <th>Driver Name</th>
                            <th>Phone Number</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody class="table-body-custom">
                        <tr *ngFor="let d of driversList">
                            <td [hidden]="tabClicked == 'all'">
                                <div class="form-checkbox">
                                    <input type="checkbox" id="{{d.id}}" [(ngModel)]="d.isSelected" name="list_name" (change)="selectShip(d)">
                                    <label for="{{d.id}}"></label></div>
                            </td>
                            <td><a routerLink="/admin/editDrive/{{d.id}}" style="text-transform:capitalize;">{{d.driverName}}</a></td>
                            <td>{{d.mobileNumber}}</td>
                            <td>
                                <div class="toggle-2">
                                    <input type="checkbox" name="onoffswitch" id="customSwitch_{{d.id}}" class="custom-control-input" (click)="changeStatus(d)" [checked]="d.status==='ACTIVE'" class="checkbox" />
                                    <label for="customSwitch_{{d.id}}" class="toggle">
              <span>ON</span><span>OFF</span>
            </label>
                                </div>
                                <!--
            <div class="custom-control custom-switch">
            <input type="checkbox"  class="custom-control-input" (click)="changeStatus(d)" id="customSwitch_{{d.id}}" [checked]="d.status==='ACTIVE'">
            <label class="custom-control-label" for="customSwitch_{{d.id}}"> </label>
          </div>
-->
                            </td>
                            <!--     <td><a class="ml-2" routerLink="/admin/editDrive/{{d.id}}">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20.25 20.25">
            <g id="pencil-black-tool-interface-symbol" transform="translate(-0.002)">
              <g id="Group_1" data-name="Group 1" transform="translate(0.002)">
                <path fill="#8A55BB" id="Path_1" data-name="Path 1" d="M0,483.655l2.127-.277L.279,481.528Z" transform="translate(-0.002 -463.405)"/>
                <path fill="#8A55BB" id="Path_2" data-name="Path 2" d="M10.875,109.069l-.218,1.672,2.572,2.572,1.672-.218,11.381-11.381-4.026-4.026Z" transform="translate(-10.272 -93.448)"/>
                <path fill="#8A55BB" id="Path_3" data-name="Path 3" d="M350.694.2A.7.7,0,0,0,350.2,0a.753.753,0,0,0-.532.223L346.92,2.97,350.946,7l2.747-2.747a.726.726,0,0,0,.02-1.026Z" transform="translate(-333.666)"/>
              </g>
            </g>
          </svg>
          </a>
          </td>-->
                            <!--  <td>{{s.driverName}}</td>
            <td>{{s.mobileNumber}}</td>
            <td>
              <div class="custom-control custom-switch">
              <input type="checkbox"  class="custom-control-input" (click)="changeStatus(s)" id="customSwitch_{{s.id}}" [checked]="s.status==='ACTIVE'">
              <label class="custom-control-label" for="customSwitch_{{s.id}}"> </label>
            </div>
            </td>-->
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr *ngIf="driversList?.length===0|| !driversList?.length">
                            <td colspan="4" class="text-center">No matching records found</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="inner-box d-block d-sm-none">
                <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
                    <thead>
                        <tr>
                            <th>Driver Name</th>
                            <th>Phone Number</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let d of driversList">
                            <td>
                                <b class=" tablesaw-cell-label">Driver Name</b>
                                <span class="tablesaw-cell-content" style="text-transform:capitalize;"><a routerLink="/admin/editDrive/{{d.id}}">{{d.driverName}}</a></span></td>
                            <td><b class=" tablesaw-cell-label">PhoneNumber</b>
                                <span class="tablesaw-cell-content">{{d.mobileNumber}}</span></td>
                            <td> <b class=" tablesaw-cell-label">Status</b>
                                <span class="tablesaw-cell-content">
              <div class="custom-control custom-switch">
              <input type="checkbox"  class="custom-control-input" (click)="changeStatus(d)" id="customSwitch_{{d.id}}" [checked]="d.status==='ACTIVE'">
              <label class="custom-control-label" for="customSwitch_{{d.id}}"> </label>
              </div></span></td>
                            <!--     <td><a class="ml-2" routerLink="/admin/editDrive/{{d.id}}">
                   <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20.25 20.25">
                   <g id="pencil-black-tool-interface-symbol" transform="translate(-0.002)">
                     <g id="Group_1" data-name="Group 1" transform="translate(0.002)">
                       <path fill="#8A55BB" id="Path_1" data-name="Path 1" d="M0,483.655l2.127-.277L.279,481.528Z" transform="translate(-0.002 -463.405)"/>
                       <path fill="#8A55BB" id="Path_2" data-name="Path 2" d="M10.875,109.069l-.218,1.672,2.572,2.572,1.672-.218,11.381-11.381-4.026-4.026Z" transform="translate(-10.272 -93.448)"/>
                       <path fill="#8A55BB" id="Path_3" data-name="Path 3" d="M350.694.2A.7.7,0,0,0,350.2,0a.753.753,0,0,0-.532.223L346.92,2.97,350.946,7l2.747-2.747a.726.726,0,0,0,.02-1.026Z" transform="translate(-333.666)"/>
                     </g>
                   </g>
                 </svg>
                 </a>
                 </td>-->
                            <!--  <td>{{s.driverName}}</td>
              <td>{{s.mobileNumber}}</td>
              <td>
                <div class="custom-control custom-switch">
                <input type="checkbox"  class="custom-control-input" (click)="changeStatus(s)" id="customSwitch_{{s.id}}" [checked]="s.status==='ACTIVE'">
                <label class="custom-control-label" for="customSwitch_{{s.id}}"> </label>
              </div>
              </td>-->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</section>
